import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-frontend/shared/api/axios";
import { toast } from "sonner";
import { tryCatch } from "@/zapi-frontend/shared/lib/tryCatch";
import { TProjectTemplate } from "./types";

export function useProjectTemplates() {
  const { data, isLoading } = useQuery({
    queryKey: ["project-templates"],
    queryFn: async () => {
      const [response, error] = await tryCatch($api.get<{ data: TProjectTemplate[] }>("/project-templates"));
      if (error) {
        toast.error(error.message);
        throw error;
      }
      return response.data.data;
    },
  });

  return {
    projectTemplates: data ?? [],
    isProjectTemplatesLoading: isLoading,
  };
}
